import React, { useEffect, useState } from "react";
import axios from 'axios';
import { URLImageAccueil, URLPageAccueil } from "../../utils/varaibleFetch";
import { Link } from "react-router-dom";



const CompoAccueilLeft = () => {

  const [article, setARticle] = useState({})
  useEffect(() => {

    axios.get(URLPageAccueil)
      .then(response => {
        const data = response.data;

        setARticle(data['hydra:member'][0])

      })
      .catch(error => {
        console.error('Erreur lors de la récupération des données :', error);
      });


  }, [])

  if (!article || Object.keys(article).length === 0) {
    return <div className="home-composition home-composition--loading" />;
  }
  return (
    <div className="home-composition">
      <Link className="home-composition__item home-composition__item--large focus-ring" to="/peinture">
        <img src={`${URLImageAccueil}${article.img1}`} alt="Aperçu peinture" />
        <span>Peinture</span>
      </Link>
      <Link className="home-composition__item home-composition__item--portrait focus-ring" to="/digital">
        <img src={`${URLImageAccueil}${article.img5}`} alt="Aperçu digital" />
        <span>Digital</span>
      </Link>
      <Link className="home-composition__item focus-ring" to="/peinture">
        <img src={`${URLImageAccueil}${article.img3}`} alt="Aperçu galerie peinture" />
        <span>Toile</span>
      </Link>
      <Link className="home-composition__item focus-ring" to="/peinture">
        <img src={`${URLImageAccueil}${article.img2}`} alt="Aperçu oeuvre urbaine" />
        <span>Urbain</span>
      </Link>
      <Link className="home-composition__item home-composition__item--wide focus-ring" to="/digital">
        <img src={`${URLImageAccueil}${article.img4}`} alt="Aperçu galerie digitale" />
        <span>Studio</span>
      </Link>
    </div>
  )
}

export default CompoAccueilLeft
